export const FETCH_RELEASES = 'RELEASES/FETCH_REQUEST';
export const FETCH_RELEASES_SUCCESS = 'RELEASES/FETCH_SUCCESS';

export const FETCH_RELEASE_BY_ID = 'RELEASE/FETCH_BY_ID_REQUEST';
export const FETCH_RELEASE_BY_ID_SUCCESS = 'RELEASE/FETCH_BY_ID_SUCCESS';

export const CREATE_RELEASE = 'RELEASE/CREATE_REQUEST';
export const CREATE_RELEASE_SUCCESS = 'RELEASE/CREATE_SUCCESS';

export const UPDATE_RELEASE = 'RELEASE/UPDATE_REQUEST';
export const UPDATE_RELEASE_SUCCESS = 'RELEASE/UPDATE_SUCCESS';

export const DELETE_RELEASE = 'RELEASE/DELETE_REQUEST';
export const DELETE_RELEASE_SUCCESS = 'RELEASE/DELETE_SUCCESS';

// Status change operations
export const PATCH_RELEASE_STATE = 'RELEASE/PATCH_STATE_REQUEST';
export const PATCH_RELEASE_STATE_SUCCESS = 'RELEASE/PATCH_STATE_SUCCESS';

export const CHECK_VERSION_EXISTS = 'RELEASE/CHECK_VERSION_EXISTS_REQUEST';

export const GET_LATEST_VERSION = 'RELEASE/GET_LATEST_VERSION_REQUEST';

// Dashboard filters
export const SET_RELEASES_DASHBOARD_FILTER = 'RELEASES/DASHBOARD/FILTERS/SET_ONE';
export const SET_RELEASES_DASHBOARD_FILTERS = 'RELEASES/DASHBOARD/FILTERS/SET_MANY';
export const REMOVE_RELEASES_DASHBOARD_FILTER = 'RELEASES/DASHBOARD/FILTERS/REMOVE_ONE';
export const CLEAR_RELEASES_DASHBOARD_FILTERS = 'RELEASES/DASHBOARD/FILTERS/CLEAR';

// UI state
export const OPEN_CREATION_MODAL = 'RELEASES/MODAL/CREATION/OPEN';
export const CLOSE_CREATION_MODAL = 'RELEASES/MODAL/CREATION/CLOSE';

export const OPEN_NOTE_MODAL = 'RELEASES/MODAL/NOTE/OPEN';
export const CLOSE_NOTE_MODAL = 'RELEASES/MODAL/NOTE/CLOSE';

export const OPEN_NOTE_CSV_MODAL = 'RELEASES/MODAL/NOTE_CSV/OPEN';
export const CLOSE_NOTE_CSV_MODAL = 'RELEASES/MODAL/NOTE_CSV/CLOSE';

export const OPEN_RELEASE_MODAL = 'RELEASES/MODAL/RELEASE/OPEN';
export const CLOSE_RELEASE_MODAL = 'RELEASES/MODAL/RELEASE/CLOSE';
export const UPDATE_RELEASE_MODAL = 'RELEASES/MODAL/RELEASE/UPDATE';

// Persisted action types for localStorage
export const PERSISTED_ACTION_TYPES = [
  SET_RELEASES_DASHBOARD_FILTER,
  SET_RELEASES_DASHBOARD_FILTERS,
  CLEAR_RELEASES_DASHBOARD_FILTERS,
  REMOVE_RELEASES_DASHBOARD_FILTER,
];
